var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img--svg",style:({width: _vm.width, height: _vm.height}),domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }